// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage by default
import { combineReducers } from 'redux';
import authReducer from '../features/auth/AuthSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';

// Set up persist config
const persistConfig = {
  key: 'root',
  storage,
};

// Combine reducers if you have more than one
const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store with the persisted reducer
const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
export default store;
